import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-13ea9424"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tab-panel-context"
};
const _hoisted_2 = {
  style: {
    "padding-bottom": "10px",
    "font-size": "14px",
    "font-weight": "500"
  }
};
const _hoisted_3 = {
  style: {
    "color": "#f28333",
    "padding-bottom": "10px",
    "font-size": "14px",
    "font-weight": "500"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane");
  const _component_a_tabs = _resolveComponent("a-tabs");
  const _component_Empty = _resolveComponent("Empty");
  const _component_a_table = _resolveComponent("a-table");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_tabs, {
    activeKey: _ctx.activeKey,
    "onUpdate:activeKey": _cache[0] || (_cache[0] = $event => _ctx.activeKey = $event),
    centered: "",
    tabPosition: "top",
    animated: {
      tabPane: true
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
      key: "1",
      tab: "实际承运人满意率"
    }), _createVNode(_component_a_tab_pane, {
      key: "2",
      tab: "托运人满意率"
    })]),
    _: 1
  }, 8, ["activeKey"]), _createElementVNode("div", _hoisted_2, " 公告日期：" + _toDisplayString(_ctx.dayjs().format('YYYY-MM')), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.activeKey === '2' ? '温馨提示：货主在平台必须发布真实的货源信息，一旦发现不实货源将直接影响货主在平台的信誉问题' : '温馨提示：恶意抢单，或定向指派单接单后，司机逾期不进行相关回退操作，系统将禁止接单若干日，并自动撤销该单据'), 1), _createVNode(_component_a_table, {
    dataSource: _ctx.data,
    columns: _ctx.columns,
    pagination: false,
    scroll: {
      y: 550,
      x: 'auto'
    }
  }, {
    emptyText: _withCtx(() => [_createVNode(_component_Empty, {
      class: "empty-context"
    })]),
    _: 1
  }, 8, ["dataSource", "columns"])]);
}